import React from 'react';

export default function Modal({ clickedImg, setClickedImg }) {
	const handleClick = (e) => {
		if (
			e.target.classList.contains('returnToMenu') ||
			e.target.classList.contains('backDrop')
		) {
			setClickedImg(null);
		}
	};
	return (
		<div className="backDrop" onClick={handleClick}>
			<div className="menuText">{clickedImg}</div>
			<h3 className="btn returnToMenu" onClick={handleClick}>
				Return to Menu
			</h3>
		</div>
	);
}
